/*

suresh 09/19/2022  2700539021  Validation Alignment issues in account Details(GAL-64)
ashraf 10/16/2022  2700539021  added code comments in search, add user management.
Raghu 26/10/2022 2700539021 Table Alignment Fixes.
Raghu 27/10/2022 2700539021 Table Buttons Alignment Fixes.
Rohini 29/10/2022 2700539021 added the classnames globally for buttons.
Ashraf 10/30/2022 2700539021 fixed table pagination issue
Ashraf 11/14/2022 2700539021 fixed column alignment to center
Sohel 12/12/2022 2700539021 Added Module Column and Window Name rename
Suresh Peddavoora 12/12/2022 2700539021 Fixed Alignment issue for Table Columns
Ashraf 12/15/2022 2700539021 changed columns order
 Suresh Peddavoora 02/24/2023 2700539021 New UI changes
//suresh peddavoora 03/03/2023 2700539021 Tables and fields alignments
Prakash  03/15/2023 2700539021 fixed alignments issue in responsive
Guru Prasad  06/26/2023 2700539021 fixed search issue in the table
Ravi  06/27/2023 2700539021 Added title and rename search to filter

*/

import {
  Checkbox,
  FilledInput,
  FormControl,
  IconButton,
  InputAdornment,
  makeStyles,
  Select,
  MenuItem,
} from '@material-ui/core';
import React, {useEffect, useState} from 'react';
import RoleCheckbox, {useTable} from './ReusableTableComponents';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import PageLoader from '../../../components/PageLoader';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Search from '@material-ui/icons/Search';
import Clear from '@material-ui/icons/Clear';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';

const useStyles = makeStyles((theme) => ({
  searchInput: {
    'backgroundColor': 'transparent !important',
    'marginBottom': '15px',
    'padding': 0,
    '& .MuiInputBase-input': {
      height: '0.6rem',
    },
  },
  customTable: {
    backgroundColor: '#32046926',
    padding: '0 !important',
  },
  clearIcon: {
    paddingTop: 6,
    fontSize: '1.5rem !important',
    color: '#707070',
    cursor: 'pointer',
  },
  searchIcon: {
    fontSize: '1.5rem !important',
    paddingBottom: 5,
  },
  selectLabel: {
    justifyContent: ' flex-end !important',
    whiteSpace: 'pre',
  },
  colHeader: {
    borderBottom: '2px solid #ffffff !important',
  },
  customRoleTable: {
    textAlign: 'center',
  },
}));

// custom table where all module details add, view, update, delete, select all are rendered with checkboxes (2700549879)
const CustomTable = ({
  columns,
  data,
  options,
  rowsPerPage,
  handleChange,
  handleInputChange,
  setTableData,
  tableData,
  allSelection,
  isAllSelectedObj,
  selectedAll,
  setRowsPerPage,
}) => {
  const classes = useStyles();
  // const [loader, setLoader] = useState(false);
  const loader = false;
  const [page, setPage] = useState(1);
  const [searchInput, setSearchInput] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [sortingState, setSortingState] = useState();
  const {slice} = useTable(filteredData, page, rowsPerPage);
  const handleSearchInput = (value) => {
    setSearchInput(value);
    const filteredData = data.filter((row) => {
      const moduleMatch = row.moduleName.toLowerCase().includes(value.toLowerCase());
      const keyMatch = row.key.toLowerCase().includes(value.toLowerCase());
      return moduleMatch || keyMatch;
    });

    setFilteredData(filteredData);
  };
  const handleSort = (sortingState) => {
    const {field, order} = sortingState;
    const sortData = [...filteredData];
    if (order === 'asc' || order === 'des') {
      const orderValue = order === 'asc' ? 1 : -1;
      sortData.sort((a, b) => {
        if (a[field] !== b[field]) {
          if (typeof a[field] === 'string') {
            return a[field].localeCompare(b[field]) * orderValue;
          } else {
            return (a[field] - b[field]) * orderValue;
          }
        }
      });
      setFilteredData(sortData);
    } else if (searchInput) {
      handleSearchInput(searchInput);
    } else {
      setFilteredData(data);
    }
  };
  // setting search bar value when table data changes (2700549879)
  useEffect(() => {
    if (data?.length > 0) {
      setFilteredData(data);
    }
  }, [data]);
  useEffect(() => {
    if (filteredData?.length > 0) {
      handleSort(sortingState);
    }
  }, [sortingState]);

  // handles pagination (2700549879)
  useEffect(() => {
    if (slice.length < 1 && page !== 1) {
      setPage(page - 1);
    }
  }, [slice, page, setPage]);

  // handles search input and sets filtered data (2700549879)
  // const handleSearchInput = (e) => {
  //   setSearchInput(e.target.value);
  //   const filteredData = data.filter((row) =>
  //     row.key.toLowerCase().includes(e.target.value.toLowerCase())
  //   );

  //   setFilteredData(filteredData);
  // };

  // handles row level add, view, update and delete (2700549879)
  const getUpdatedObject = (title, each, bool) => {
    if (title === 'Add') {
      return {
        ...each,
        add: bool,
        view: each?.view ? each.view : bool,
      };
    } else if (title === 'Update') {
      return {
        ...each,
        update: bool,
        view: each?.view ? each.view : bool,
      };
    } else if (title === 'Delete') {
      return {
        ...each,
        delete: bool,
        view: each?.view ? each.view : bool,
      };
    } else if (title === 'View') {
      if (bool === true) {
        return {
          ...each,
          view: bool,
        };
      } else if (bool === false) {
        return {
          ...each,
          add: bool,
          update: bool,
          delete: bool,
          view: bool,
        };
      }
    }
  };
  const handleChangeOrder = (pv, title) => {
    if (pv?.title === title) {
      if (pv.order === 'asc') {
        return 'des';
      } else if (pv.order === 'des') {
        return 'default';
      } else {
        return 'asc';
      }
    } else {
      return 'asc';
    }
  };
  const getIcon = (obj, title) => {
    if (obj?.title === title) {
      if (obj.order === 'asc') {
        return <ArrowUpwardIcon className="sort-icon" />;
      } else if (obj.order === 'des') {
        return <ArrowDownwardIcon className="sort-icon" />;
      }
    }
  };
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  return (
    <div
      className={`global-field-table mui-custom-table-container custom-mui-table role-management-table new-standard-textfields ${classes.customTable}`}
    >
      {options.search && (
        // custom search bar for table (2700549879)
        <div className="add-Role-search w-100 d-flex align-items-center justify-content-end">
          <div className="mr-auto ml-2">
            <h6 className="mb-0 role-module-title">Module Details</h6>
          </div>
          <div className="mr-1">
            <FormControl sx={{m: 1, width: '25ch'}} variant="filled">
              <FilledInput
                className={classes.searchInput}
                value={searchInput}
                aria-describedby="filled-weight-helper-text"
                onChange={(e) => handleSearchInput(e.target.value)}
                onKeyPress={(e) => {
                  e.key === 'Enter' && e.preventDefault();
                }}
                inputProps={{
                  'aria-label': 'weight',
                }}
                placeholder="Filter"
                startAdornment={
                  <InputAdornment position="start">
                    <Search className={classes.searchIcon} />
                  </InputAdornment>
                }
                endAdornment={
                  <InputAdornment position="end">
                    <Clear
                      className={classes.clearIcon}
                      onClick={() => {
                        setSearchInput('');
                        setFilteredData(data);
                      }}
                    />
                  </InputAdornment>
                }
              />
            </FormControl>
          </div>
        </div>
      )}
      <div className="w-100 table-overflow">
        <table className="add-custom-table new-standard-textfields">
          <thead className={classes.colHeader}>
            <tr>
              <th></th>
              <th></th>
              <th>Functionalities</th>
              <th></th>
              <th></th>
              <th style={{width: '150px'}}>
                <FormGroup className={`check-block`}>
                  <FormControlLabel
                    // select all checkbox
                    className={`global-fields-checkbox ${classes.selectLabel}`}
                    control={
                      <Checkbox
                        disabled={tableData?.length <= 0}
                        name="selectAll"
                        label="Select All"
                        checked={selectedAll}
                        onChange={(eve, selection) => {
                          allSelection(eve, selection);
                        }}
                        icon={icon}
                        checkedIcon={<CheckBoxIcon fontSize="small" className="selectcheckBox" />}
                        inputProps={{'aria-label': 'controlled'}}
                      />
                    }
                    label="Select All"
                  />
                </FormGroup>
              </th>
              <th></th>
            </tr>
          </thead>

          <thead className="custom-table-icon">
            <tr>
              {columns.map(
                ({title, hidden = false}) =>
                  !hidden && (
                    <th key={title} className="custom-table-icon-block">
                      {
                        // header columns add, view, update and delete all checkboxes (2700549879)
                        <>
                          <span
                            onClick={() => {
                              if (title === 'Module') {
                                setSortingState((pv) => {
                                  const obj = {...pv};
                                  obj.title = 'Module';
                                  obj.field = 'moduleName';
                                  obj.order = handleChangeOrder(pv, title);
                                  return obj;
                                });
                              } else if (title === 'Function-Window') {
                                setSortingState((pv) => {
                                  const obj = {...pv};
                                  obj.title = 'Function-Window';
                                  obj.field = 'key';
                                  obj.order = handleChangeOrder(pv, title);
                                  return obj;
                                });
                              }
                            }}
                          >
                            {title}
                          </span>
                          {(title === 'Function-Window' || title === 'Module') &&
                            getIcon(sortingState, title)}
                          {title !== 'Function-Window' &&
                            title !== 'Module' &&
                            title !== 'Is Favorite' && (
                            <Checkbox
                              disabled={tableData?.length <= 0}
                              checked={
                                tableData?.length > 0 ?
                                  isAllSelectedObj[title.toLowerCase()] :
                                  false
                              }
                              icon={icon}
                              checkedIcon={
                                <CheckBoxIcon fontSize="small" className="selectcheckBox" />
                              }
                              onChange={(e, selection) => {
                                if (selection === true) {
                                  const filteredArr = tableData?.map((each) => {
                                    return getUpdatedObject(title, each, selection);
                                  });
                                  setTableData(filteredArr);
                                } else if (selection === false) {
                                  const filteredArr2 = tableData?.map((each) => {
                                    return getUpdatedObject(title, each, selection);
                                  });
                                  setTableData(filteredArr2);
                                }
                              }}
                            />
                          )}
                        </>
                      }
                    </th>
                  ),
              )}
            </tr>
          </thead>
          <tbody>
            {slice && slice.length > 0 ? (
              slice.map((rowData, i) => {
                // row level add, view, update and delete checkboxes (2700549879)
                return (
                  <tr key={i}>
                    <td>{rowData?.moduleName}</td>
                    <td>{rowData.key}</td>
                    <td className={classes.customRoleTable}>
                      <RoleCheckbox
                        name="view"
                        index={i}
                        rowData={rowData}
                        handleChange={handleChange}
                        handleInputChange={handleInputChange}
                      />
                    </td>
                    <td className={classes.customRoleTable}>
                      <RoleCheckbox
                        name="add"
                        index={i}
                        rowData={rowData}
                        handleChange={handleChange}
                        handleInputChange={handleInputChange}
                        isAllSelectedObj={isAllSelectedObj}
                      />
                    </td>
                    <td className={classes.customRoleTable}>
                      <RoleCheckbox
                        name="update"
                        index={i}
                        rowData={rowData}
                        handleChange={handleChange}
                        handleInputChange={handleInputChange}
                      />
                    </td>
                    <td className={classes.customRoleTable}>
                      <RoleCheckbox
                        name="delete"
                        index={i}
                        rowData={rowData}
                        handleChange={handleChange}
                        handleInputChange={handleInputChange}
                      />
                    </td>
                    <td className={classes.customRoleTable}>
                      <RoleCheckbox
                        name="favourite"
                        index={i}
                        rowData={rowData}
                        handleChange={handleChange}
                        handleInputChange={handleInputChange}
                      />
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td className="text-center" colSpan={columns.length}>
                  No records to display
                </td>
              </tr>
            )}
            {loader && <PageLoader />}
          </tbody>
        </table>
      </div>
      <div className="add-Role-search w-100 d-flex align-items-center py-2 justify-content-end new-standard-textfields custom-table-footer">
        <span className="mb-0 table-rows">Rows per screen : </span>
        <Select
          className="addrole-pagination"
          renderValue={(value) => `${value}`}
          disableUnderline={true}
          value={rowsPerPage}
          onChange={(e) => setRowsPerPage(Number(e.target.value))}
        >
          {[15, 20, 25].map((option) => {
            // custom table pagination (2700549879)
            return (
              <MenuItem value={option} key={option}>
                {option}
              </MenuItem>
            );
          })}
        </Select>
        <div className="mr-3">
          <IconButton disabled={page === 1} onClick={() => setPage(page - 1)}>
            <ChevronLeft />
          </IconButton>
          <span className="table-pages">
            <span className="mr-1">Page</span>
            <span>{filteredData?.length === 0 ? 0 : page}</span>
            <span className="mx-1">of</span>
            <span>{Math.ceil(filteredData.length / rowsPerPage)}</span>
          </span>
          <IconButton
            disabled={
              filteredData?.length === 0 || page === Math.ceil(filteredData.length / rowsPerPage)
            }
            onClick={() => setPage(page + 1)}
          >
            <ChevronRight />
          </IconButton>
        </div>
      </div>
    </div>
  );
};

export default CustomTable;
